import React, { useState,useEffect } from "react";
import Navbar from "../components/Navbar/Index";
import { useOutletContext,Link } from "react-router-dom";
import UserTable from "./UserTable";
import axios from "axios";
import { useDispatch } from 'react-redux';
import {updateFriends} from '../actions/FriendsActions';
import { useSelector } from 'react-redux';
function Table() {
  const [sidebarToggle] = useOutletContext();

  const [loading] = useState(false);
  // const [friends, setFriends] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));
  const dispatch = useDispatch();
  const friends = useSelector(state => state.Friends);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('https://splithub-dev.salmonocean-218390b4.centralindia.azurecontainerapps.io/friends/GetAllFriends', {
          headers: {
            Authorization: `Bearer ${user?.idToken }`
          }
        });
        // setFriends(response.data);
        dispatch(updateFriends(response.data));

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []); // Empty dependency array to run effect only once on component mount
  const dataHeader = [
    {
      key: "name",
      label: "Name",
    },
    {
      key: "email",
      label: "Email",
    },
    
  ];
  const data = [];
  if (friends.length>=1){
    friends.map((item)=>{
      data.push({email:item.email,
      picture:item.profile_pic,
      name:item.name})
    })
  }
  return (
    <>
      <main className="h-full">
        <Navbar toggle={sidebarToggle} />

        {/* Main Content */}
        <div className="mainCard">
          <div className="border w-full border-gray-200 bg-white py-4 px-6 rounded-md">
            <UserTable
              loading={loading}
              dataHeader={dataHeader}
              data={data}
            />
          </div>
        </div>
        <div className="fixed bottom-20 right-8">
              <div className="relative">
            <Link to="/form">
            <button className="plus-button rounded-full bg-green-500 text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"  style={{width: "40px", height: "40px"}}>
              +
            </button>
            </Link>
          
           
          </div>
        </div>
  
      </main>
    </>
  );
}

export default Table;
